import { GalaxyBackground } from './components/GalaxyBackground'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'
import { SmoothScroll } from './components/SmoothScroll'
import { WhatsAppButton } from './components/WhatsAppButton'
import { Hero } from './sections/Hero'
import { Services } from './sections/Services'
import { Stats } from './sections/Stats'
import { Process } from './sections/Process'
import { Method } from './sections/Method'
import { CTA } from './sections/CTA'
import { Contact } from './sections/Contact'

function App() {
  return (
    <SmoothScroll>
      <GalaxyBackground />
      <div className="relative z-10">
        <Navbar />
        <main className="relative">
          <Hero />
          <Services />
          <Stats />
          <Process />
          <Method />
          <CTA />
          <Contact />
        </main>
        <Footer />
      </div>
      <WhatsAppButton />
    </SmoothScroll>
  )
}

export default App
